import t from 'prop-types';

// eslint-disable-next-line
export const total = t.shape({});

export const creditCardPaymentMethod = t.shape({
  method: t.oneOf(['credit_card']).isRequired,
  cardType: t.string,
  expiryMonth: t.string,
  expiryYear: t.string,
  lastFourDigits: t.string,
});

export const voucherPaymentMethod = t.shape({
  method: t.oneOf(['voucher']).isRequired,
  code: t.string,
  brand: t.string,
});

export const pointsPaymentMethod = t.shape({
  method: t.oneOf(['points']).isRequired,
  qffNumber: t.string,
});

export const creditNotePaymentMethod = t.shape({
  method: t.oneOf(['credit_note']).isRequired,
  brand: t.string,
  lastFourCharacters: t.string,
  expiry: t.string,
});

const qantasGroupCreditVoucherPaymentMethod = t.shape({
  method: t.oneOf(['qantas_group_credit_voucher']).isRequired,
  cardNumber: t.string | null,
});

const qantasTravelPassPaymentMethod = t.shape({
  method: t.oneOf(['qantas_travel_pass', 'qantas_group_credit_voucher']),
  cardNumber: t.string,
  expiryMonth: t.string,
  expiryYear: t.string,
});

export const paymentBreakdownItem = t.shape({
  total: total.isRequired,
  method: t.oneOf(['credit_card', 'voucher', 'points', 'credit_note', 'qantas_travel_pass', 'qantas_group_credit_voucher']),
  paymentMethods: t.arrayOf(
    t.oneOfType([
      creditCardPaymentMethod,
      voucherPaymentMethod,
      pointsPaymentMethod,
      creditNotePaymentMethod,
      qantasTravelPassPaymentMethod,
      qantasGroupCreditVoucherPaymentMethod,
    ]),
  ).isRequired,
});
